var $1a750506d5a4610f$exports = {};
$1a750506d5a4610f$exports = {
    "Empty": `Vac\xedo`
};


export {$1a750506d5a4610f$exports as default};
//# sourceMappingURL=es-ES.mjs.map
